import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectOutcomeModel } from '../../../../../hub_schema/hubTypes';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateOutcomeDialogComponent } from '../create-outcome-dialog/create-outcome-dialog.component';

const GREENHOUSE_GAS_MITIGATION_METRIC_ID: number = 1014;

@Component({
    selector: 'app-edit-outcome-dialog',
    templateUrl: './edit-outcome-dialog.component.html',
    styleUrls: ['./edit-outcome-dialog.component.scss'],
    standalone: false
})
export class EditOutcomeDialogComponent implements OnInit {
    // dependencies
    private dialogRef: MatDialogRef<CreateOutcomeDialogComponent> = inject(MatDialogRef<CreateOutcomeDialogComponent>);
    private dialogData: any = inject(MAT_DIALOG_DATA);

    public projectOutcome: ProjectOutcomeModel;
    public outcomeWizardForm: FormGroup;
    public isStrategy: boolean;
    public is2030Goals: boolean;

    public ngOnInit(): void {
        this.isStrategy = this.dialogData.isStrategy;
        this.projectOutcome = this.dialogData.projectOutcome;
        this.is2030Goals = !!this.projectOutcome.outcome;

        this.outcomeWizardForm = new FormGroup({
            projectOutcomeId: new FormControl({
                value: undefined,
                disabled: false
            }),
            sortOrder: new FormControl(null),
            projectId: new FormControl(null),
            outcomeStatistics: new FormControl(null),
            outcome: new FormGroup({
                outcomeId: new FormControl({
                    value: undefined,
                    disabled: false
                }),
                uniqueId: new FormControl(''),
                outcomeMetricId: new FormControl(0),
                outcomeMetric: new FormControl(null),
                outcomeUnitId: new FormControl(0),
                outcomeUnit: new FormControl(null),
                parentOutcomes: new FormControl([])
            }),
            customOutcome: new FormGroup({
                customOutcomeId: new FormControl({
                    value: undefined,
                    disabled: false
                }),
                uniqueId: new FormControl(''),
                indicatorName: new FormControl(''),
                isCalculatedAsRate: new FormControl(false),
                unit: new FormControl(''),
                parentCustomOutcomes: new FormControl([])
            }),
            statement: new FormControl('', Validators.required),
            isPolicyLeverageOutcome: new FormControl(false)
        });

        this.outcomeWizardForm.patchValue(this.projectOutcome);
    }

    public getValidationErrorMessages(formControlName: string): string {
        const formControl = this.outcomeWizardForm!.controls[formControlName];
        return formControl.errors ? 'required' : '';
    }

    public cancelDialog(): void {
        this.dialogRef.close();
    }

    public saveProjectOutcome(): void {
        const projectOutcome: ProjectOutcomeModel = this.outcomeWizardForm.value;

        if (projectOutcome.projectOutcomeId === null) {
            projectOutcome.projectOutcomeId = undefined;
        }

        if (projectOutcome.outcome != null && projectOutcome.outcome.outcomeId === null) {
            projectOutcome.outcome.outcomeId = undefined;
        }

        if (this.is2030Goals) {
            projectOutcome.customOutcome = undefined;
        } else {
            projectOutcome.outcome = undefined;
        }

        this.dialogRef.close(projectOutcome);
    }
}
